// src/StaffLogin.jsx  (same as Student login flow -> goes to HomePage after login)
import React from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import { signOut } from "firebase/auth";
import Login from "./Login";

export default function StaffLogin() {
  const navigate = useNavigate();

  const onLogin = async () => {
    const u = auth.currentUser;
    if (!u) throw new Error("Login failed. Please try again.");

    // ✅ staff uses same access as student: must NOT be driver/admin
    const uid = u.uid;
    const [driverSnap, adminSnap] = await Promise.all([
      getDoc(doc(db, "drivers", uid)),
      getDoc(doc(db, "admins", uid)),
    ]);

    if (driverSnap.exists() || adminSnap.exists()) {
      await signOut(auth);
      throw new Error("This account is not registered as STAFF.");
    }

    navigate("/", { replace: true }); // Root -> HomePage
  };

  return (
    <Login
      role="staff"
      title="Staff Login"
      subtitle="Email/Password only"
      onLogin={onLogin}
    />
  );
}